import * as React from 'react'
import { useSelector } from 'react-redux'
import { Box, styled, Stack } from '@mui/material'
import { Typography as MIUTypography } from '@mui/material'
import ValidationAccount from '../../components/ValidationAccount'

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '1.125em',
  fontWeight: props.istitle ? 700 : 450,
  lineHeight: props.istitle ? '24px' : '24px',
  color: props.istitle ? '#1B1C37' : '#6A6A6A',
  textAlign: 'center',
}))

const styleStack = {
  direction: 'column',
  alignItems: 'center',
  py: 2,
  px: '8vw',
  height: '100%',
  spacing: 2,
  width: '100%',
}

const AuthorizeAccountPage = () => {
  const _state = useSelector(state => state.drawerLeft)

  const styleBox = {
    marginLeft: _state.open ? _state.drawerWidth : 0,
    marginTop: _state.drawerHeight,
    height: _state.contentBox,
    width: 'inherit',
    overflow: 'auto',
    scrollBehavior: 'smooth',
  }

  return (
    <Box component="div" style={styleBox}>
      <Stack {...styleStack}>
        <Box>
          <Typography istitle="true">Proyecto 17-DI-FARNR-2021</Typography>
          <Typography istitle="true" sx={{ textTransform: 'uppercase' }}>
            “Dinámica de crecimiento y servicios ecosistémicos del arbolado urbano de la
            ciudad de Loja”
          </Typography>
        </Box>
        <Box pt={2}>
          <Typography istitle="true">Validación de cuenta</Typography>
        </Box>
        <ValidationAccount />
      </Stack>
    </Box>
  )
}

export default AuthorizeAccountPage
